import React from 'react'
import MapContainer from '../Map/MapContainer'
import MapMenuContainer from '../MapMenu/MapMenuContainer'
import MapMessageContainer from '../MapMessage/MapMessageContainer'
import { withStyles } from '@material-ui/core/styles'

const styles = {
	map: {
		position: 'relative',
		height: '100%',
		justifyContent: 'center',
		display: 'flex',
		flexDirection: 'column-reverse'
	},
	controls: {
		display: 'flex'
	}
}

const NarrowMapArea = ({ classes })	=> (
	<React.Fragment >
        <div className={classes.controls}>
        	<MapMenuContainer />
        </div>
        <div className={classes.map}>
			<MapMessageContainer />
			<MapContainer />
		</div>
	</React.Fragment>
)

export default withStyles(styles)(NarrowMapArea)



// WEBPACK FOOTER //
// ./src/components/Layout/NarrowMapArea.js